import { call, put, delay, select, takeLatest } from 'redux-saga/effects';
import { PHOTO_CAPTURE_GET_AUTHENTICATION_DATA_REQUEST, photoCaptureDataFailureAction, photoCaptureGetAuthenticationDataSuccessAction } from '../actions';
import { GPCLoaderConstants } from '../constants';
import { PhotoCaptureAuthenticationService } from '../services';
import { getRefreshDelayMs, updateAccessToken, getAccessTokenForAuthentication } from '../utilities';
export function* photoCaptureAuthenticationRefreshWorkerSaga(coCode, contextId, photoCaptureAuthenticationService = new PhotoCaptureAuthenticationService()) {
    while (true) {
        const currentAuthToken = yield select(state => state.domain.photoCapture.authToken);
        const refreshDelayMs = getRefreshDelayMs(currentAuthToken);
        if (refreshDelayMs === null) {
            yield delay(GPCLoaderConstants.TOKEN_PARSE_RETRY_DELAY_MS);
            continue;
        }
        yield delay(refreshDelayMs);
        const accessToken = getAccessTokenForAuthentication();
        try {
            const response = yield call({
                context: photoCaptureAuthenticationService,
                fn: photoCaptureAuthenticationService.photoCaptureGetAuthenticationData
            }, coCode, contextId, accessToken);
            yield put(photoCaptureGetAuthenticationDataSuccessAction(response.result));
            updateAccessToken(response && response.result && response.result.authToken);
        }
        catch (error) {
            yield put(photoCaptureDataFailureAction(error.toString()));
        }
    }
}
export function* photoCaptureAuthenticationRefreshWatcherSaga(photoCaptureAuthenticationService = new PhotoCaptureAuthenticationService()) {
    yield takeLatest(PHOTO_CAPTURE_GET_AUTHENTICATION_DATA_REQUEST, function* ({ payload: { coCode, contextId } }) {
        yield call(photoCaptureAuthenticationRefreshWorkerSaga, coCode, contextId, photoCaptureAuthenticationService);
    });
}
//# sourceMappingURL=intelligentPhotoCaptureRefreshAuthenticationSaga.js.map